// Datafil för landningssidor — rättsområdesspecifika SEO-sidor.
// Lägg till en ny entry här för att skapa en ny landningssida.
// Sidan renderas av /app/frontend/src/pages/LandingPage.jsx via routen /:slug.

export const LANDING_PAGES = {
    bodelning: {
        slug: "bodelning",
        seoTitle: "Bodelning — jurist hjälper dig vid skilsmässa & separation",
        seoDescription:
            "Behöver du hjälp med bodelning vid skilsmässa, äktenskapsskillnad eller separation? BM Juridik företräder dig genom hela processen. Boka rådgivning idag.",
        eyebrow: "Bodelning",
        h1: "Bodelning —",
        h1Italic: "rätt fördelning, rätt från början.",
        intro:
            "Vid skilsmässa eller separation ska makarnas tillgångar fördelas. En korrekt bodelning är avgörande för att undvika framtida konflikter och säkerställa att du får det du har rätt till. Vi företräder dig professionellt och med integritet — i hela Sverige.",
        primaryCta: "Boka rådgivning",
        ctaHref: "#kontakt",
        showFreeBadge: false,
        statBlocks: [
            { value: "12+", label: "års erfarenhet" },
            { value: "6", label: "kontor i Sverige" },
            { value: "24h", label: "svar på din förfrågan" },
        ],
        services: [
            {
                title: "Bodelning vid äktenskapsskillnad",
                body: "Fördelning av giftorättsgods enligt äktenskapsbalken — från enkla bodelningsavtal till komplicerade tillgångsstrukturer.",
            },
            {
                title: "Bodelning för sambor",
                body: "Sambor delar bara samboegendom (bostad och bohag) — vi hjälper dig att navigera reglerna i sambolagen.",
            },
            {
                title: "Bodelning vid dödsfall",
                body: "När en make avlider sker bodelning innan arvskifte. Vi företräder efterlevande make eller bröstarvingar.",
            },
            {
                title: "Bodelningsförrättare",
                body: "När parterna inte kan enas kan tingsrätten förordna en bodelningsförrättare. Vi företräder dig under processen.",
            },
            {
                title: "Värderingsfrågor",
                body: "Bostäder, företag, pensionsförsäkringar — vi hjälper dig med korrekt värdering och fördelning.",
            },
            {
                title: "Bodelningsavtal",
                body: "Skriftligt avtal som säkrar fördelningen juridiskt och förhindrar framtida tvister.",
            },
        ],
        process: [
            {
                title: "Inledande rådgivning",
                body: "Vi går igenom din situation, era tillgångar och skulder, samt vad som är giftorättsgods respektive enskild egendom.",
            },
            {
                title: "Inventering & värdering",
                body: "Vi hjälper er sammanställa alla tillgångar, skulder och få korrekta värderingar — inklusive bostad, försäkringar och pension.",
            },
            {
                title: "Förhandling & avtal",
                body: "I de flesta fall når vi en uppgörelse genom förhandling. Vi upprättar ett juridiskt bindande bodelningsavtal.",
            },
            {
                title: "Vid oenighet",
                body: "Om ni inte kan enas ansöker vi om bodelningsförrättare hos tingsrätten — och företräder dig under hela processen.",
            },
        ],
        whyUs: [
            { title: "Erfaren familjerättsjurist", body: "Lång erfarenhet av bodelningsärenden." },
            { title: "Helhetsgrepp", body: "Vi hanterar både juridik och förhandling." },
            { title: "Hela Sverige", body: "6 kontor + digitala möten." },
            { title: "Tydlig prismodell", body: "Inga dolda avgifter." },
            { title: "Diskretion", body: "Ekonomiska frågor kräver konfidentialitet." },
            { title: "Snabb återkoppling", body: "Svar inom 24 timmar." },
        ],
        faq: [
            {
                q: "När ska bodelning ske?",
                a: "Bodelning sker normalt efter att äktenskapsskillnaden vunnit laga kraft. För sambor sker bodelning när samboförhållandet upphör, men måste begäras inom ett år.",
            },
            {
                q: "Vad är skillnaden mellan giftorättsgods och enskild egendom?",
                a: "Giftorättsgods delas lika vid bodelning. Enskild egendom delas inte — det kan vara egendom som gjorts enskild genom äktenskapsförord, gåva eller arv.",
            },
            {
                q: "Måste vi vara överens för att göra en bodelning?",
                a: "Nej. Om ni inte kan enas kan tingsrätten förordna en bodelningsförrättare som beslutar om fördelningen. Det är ofta en sista utväg när förhandling inte lyckats.",
            },
            {
                q: "Vad kostar en bodelning?",
                a: "Det varierar kraftigt beroende på komplexitet och om parterna är överens. Enkla ärenden kan klaras på några timmar; komplicerade tvister kan dra ut i tid. Vi går igenom kostnadsbilden tidigt.",
            },
            {
                q: "Kan ni hjälpa även om vi bara behöver ett bodelningsavtal?",
                a: "Absolut. Vi upprättar bodelningsavtal till fast pris för par som är överens men vill säkra fördelningen juridiskt korrekt.",
            },
        ],
        relatedPaket: ["aktenskapsforord", "samboavtal"],
        relatedPages: [
            { label: "Vårdnadstvist", to: "/vardnadstvist" },
            { label: "Testamente", to: "/testamente" },
            { label: "Familjerätt", to: "/tjanster#familjeratt" },
        ],
    },

    testamente: {
        slug: "testamente",
        seoTitle: "Testamente — upprätta lagligt korrekt testamente",
        seoDescription:
            "Säkerställ att din kvarlåtenskap fördelas enligt din vilja. BM Juridik upprättar testamente till fast pris (3 500 kr) — granskat av jurist.",
        eyebrow: "Testamente",
        h1: "Testamente —",
        h1Italic: "din vilja, juridiskt säkrad.",
        intro:
            "Ett korrekt upprättat testamente är ditt sätt att bestämma vad som ska hända med din kvarlåtenskap. Utan testamente fördelas allt enligt arvsordningen — vilket sällan motsvarar dina önskemål. Vi hjälper dig att upprätta ett testamente som verkligen står sig.",
        primaryCta: "Beställ testamente — 3 500 kr",
        ctaHref: "/paket?prod=testamente",
        showFreeBadge: false,
        statBlocks: [
            { value: "3 500 kr", label: "fast pris" },
            { value: "1-2", label: "veckor leveranstid" },
            { value: "100%", label: "juristgranskat" },
        ],
        services: [
            {
                title: "Enskilt testamente",
                body: "Reglerar din kvarlåtenskap individuellt. Idealisk för ensamstående eller när du vill göra avsteg från arvsordningen.",
            },
            {
                title: "Inbördes testamente",
                body: "För makar och sambor — reglerar arv mellan er och vidare till barn eller andra arvingar.",
            },
            {
                title: "Enskild egendom",
                body: "Säkerställ att arv blir mottagarens enskilda egendom — viktigt vid framtida skilsmässa.",
            },
            {
                title: "Förmånstagarförordnande",
                body: "Komplettera testamentet med rätt mottagare för pensions- och försäkringskapital.",
            },
            {
                title: "Förvar & registrering",
                body: "Vi hjälper med säker förvaring, alternativt anmälan till särskilda testamentsregister.",
            },
            {
                title: "Ändring & återkallelse",
                body: "Livet förändras — vi hjälper dig uppdatera ditt testamente när omständigheterna ändras.",
            },
        ],
        process: [
            {
                title: "Genomgång av önskemål",
                body: "Vi går igenom din familjesituation, vilka tillgångar du har och hur du vill att de ska fördelas.",
            },
            {
                title: "Juridisk strukturering",
                body: "Vi översätter dina önskemål till juridiskt korrekt formulering — med hänsyn till laglott, basbelopp och arvsordning.",
            },
            {
                title: "Granskning & bevittning",
                body: "Du får dokumentet att gå igenom. När du är nöjd hjälper vi dig med korrekt bevittning enligt formkraven.",
            },
            {
                title: "Säker förvaring",
                body: "Vi rekommenderar säker förvaring och kan hjälpa dig med det. Du får också digital kopia och instruktioner.",
            },
        ],
        whyUs: [
            { title: "Fast pris från 3 500 kr", body: "Inga överraskningar." },
            { title: "Juristgranskat", body: "Inte mall — verkligt skräddarsytt." },
            { title: "Hela Sverige", body: "Hanteras digitalt eller på närmaste kontor." },
            { title: "1-2 veckor leverans", body: "Snabb och professionell handläggning." },
            { title: "Anpassat till dig", body: "Vi tar hänsyn till just din situation." },
            { title: "Möjlighet till uppdatering", body: "Reviderbart till rabatterat pris." },
        ],
        faq: [
            {
                q: "Behöver jag verkligen ett testamente?",
                a: "Om du vill göra avsteg från arvsordningen — t.ex. ge mer till sambo, säkerställa att arv blir enskild egendom för dina barn, eller dela till någon utanför närmaste arvingar — behöver du ett testamente. Annars fördelas allt enligt lag.",
            },
            {
                q: "Vad kostar det att skriva testamente hos er?",
                a: "Vårt fasta pris för testamente är 3 500 kr inkl. moms. Det inkluderar genomgång av din situation, upprättande, juridisk granskning och instruktioner för bevittning och förvaring.",
            },
            {
                q: "Hur länge gäller ett testamente?",
                a: "Ett testamente gäller tills det återkallas eller ersätts av ett nyare. Vi rekommenderar att du ser över ditt testamente vart femte år eller vid större livshändelser (giftermål, skilsmässa, barn, fastighetsköp, arv).",
            },
            {
                q: "Måste testamentet bevittnas?",
                a: "Ja. Två samtidigt närvarande vittnen krävs. Vittnena måste vara över 15 år och inte stå i nära släktskap till dig eller arvingen. Vi guidar dig genom processen.",
            },
            {
                q: "Kan jag göra någon helt arvlös?",
                a: "Bröstarvingar (barn) har rätt till sin laglott — hälften av det de annars hade ärvt. Övriga arvingar (t.ex. syskon) kan göras helt arvlösa genom testamente.",
            },
        ],
        relatedPaket: ["testamente"],
        relatedPages: [
            { label: "Framtidsfullmakt", to: "/paket?prod=framtidsfullmakt" },
            { label: "Bouppteckning", to: "/paket?prod=bouppteckning" },
            { label: "Bodelning", to: "/bodelning" },
        ],
    },

    brottmal: {
        slug: "brottmal",
        seoTitle: "Brottmål — försvarare med erfarenhet av tingsrätt & hovrätt",
        seoDescription:
            "Misstänkt eller åtalad? BM Juridik företräder dig som offentlig försvarare eller målsägandebiträde i hela Sverige. Boka rådgivning idag.",
        eyebrow: "Brottmål",
        h1: "Brottmål —",
        h1Italic: "din rätt till försvar.",
        intro:
            "Som misstänkt har du rätt till en kvalificerad försvarare. Som målsägande har du rätt att få stöd och företrädas. BM Juridik agerar både som offentlig försvarare och målsägandebiträde — i tingsrätt, hovrätt och Högsta domstolen.",
        primaryCta: "Boka rådgivning",
        ctaHref: "#kontakt",
        showFreeBadge: false,
        statBlocks: [
            { value: "12+", label: "års processvana" },
            { value: "6", label: "kontor i Sverige" },
            { value: "Alla", label: "instanser" },
        ],
        services: [
            {
                title: "Offentlig försvarare",
                body: "Vi företräder dig som misstänkt eller tilltalad — från förundersökning till dom i alla instanser.",
            },
            {
                title: "Privat försvarare",
                body: "I situationer där du själv vill välja försvarare, eller när offentlig försvarare inte beviljas.",
            },
            {
                title: "Målsägandebiträde",
                body: "Om du är brottsoffer hjälper vi dig genom processen och vid skadeståndsfrågor.",
            },
            {
                title: "Förundersökning",
                body: "Tidig juridisk rådgivning kan vara avgörande. Vi finns med från första förhör.",
            },
            {
                title: "Häktningsförhandlingar",
                body: "Snabb och kompetent representation när friheten står på spel.",
            },
            {
                title: "Överklaganden",
                body: "Felaktig dom? Vi hjälper dig att överklaga till hovrätt eller Högsta domstolen.",
            },
        ],
        process: [
            {
                title: "Initialt samtal",
                body: "Beskriv situationen — anhållen, kallad till förhör, åtalad. Vi gör en inledande bedömning av läget.",
            },
            {
                title: "Förordnande",
                body: "Vi ansöker om att bli förordnade som offentlig försvarare eller målsägandebiträde — vid bifall står staten för kostnaden.",
            },
            {
                title: "Förundersökning & strategi",
                body: "Vi går igenom utredningen, närvarar vid förhör och bygger en försvarsstrategi.",
            },
            {
                title: "Process i rätten",
                body: "Vi företräder dig under huvudförhandlingen — från sakframställning till plädering och eventuellt överklagande.",
            },
        ],
        whyUs: [
            { title: "Processvana", body: "Lång erfarenhet av tingsrätt & hovrätt." },
            { title: "Hela Sverige", body: "6 kontor + digital tillgänglighet." },
            { title: "Diskretion", body: "Strikt sekretess i alla led." },
            { title: "Snabb tillgänglighet", body: "Tidig kontakt är ofta avgörande." },
            { title: "Tydlig kommunikation", body: "Vi förklarar varje steg." },
            { title: "Strategiskt försvar", body: "Skräddarsydd för ditt ärende." },
        ],
        faq: [
            {
                q: "Måste jag betala försvararen själv?",
                a: "I de flesta fall där brottet kan ge fängelse beviljar tingsrätten offentlig försvarare och staten står för kostnaden. Vid friande dom slipper du betala — vid fällande dom kan du behöva betala en del av kostnaden beroende på inkomst.",
            },
            {
                q: "Får jag välja vilken försvarare jag vill ha?",
                a: "Ja. Du har rätt att önska en specifik försvarare, och tingsrätten godkänner ofta önskemålet. Säg uttryckligen att du önskar Daniel Madsen / BM Juridik.",
            },
            {
                q: "Vad gör jag om polisen vill förhöra mig?",
                a: "Du har rätt att ha en försvarare närvarande vid förhör. Begär detta direkt. Säg inget i sak innan din försvarare kommer på plats.",
            },
            {
                q: "Hur länge tar ett brottmål?",
                a: "Det varierar — från några månader vid enklare ärenden till flera år vid omfattande mål. Häktade ärenden prioriteras och har ofta huvudförhandling inom några veckor.",
            },
            {
                q: "Kan ni företräda målsägande också?",
                a: "Ja. Vi agerar som målsägandebiträde — företräder dig som brottsoffer i rätten och hjälper dig med skadeståndsanspråk.",
            },
        ],
        relatedPaket: [],
        relatedPages: [
            { label: "Rättshjälp", to: "/rattshjalp" },
            { label: "Vårdnadstvist", to: "/vardnadstvist" },
        ],
    },

    "arbetsratt-uppsagning": {
        slug: "arbetsratt-uppsagning",
        seoTitle: "Felaktig uppsägning — jurist företräder anställda",
        seoDescription:
            "Har du blivit uppsagd och misstänker att det inte gått rätt till? BM Juridik företräder anställda mot arbetsgivare. Boka kostnadsfri första bedömning.",
        eyebrow: "Arbetsrätt",
        h1: "Felaktig uppsägning —",
        h1Italic: "din rätt som anställd.",
        intro:
            "Att bli uppsagd är ofta en chock — och ibland sker det utan att arbetsgivaren följt lagen. Vi hjälper dig att utvärdera om uppsägningen är saklig, om turordningsregler följts och vad du har rätt till. Första bedömningen är kostnadsfri.",
        primaryCta: "Boka kostnadsfri bedömning",
        ctaHref: "#kontakt",
        showFreeBadge: true,
        freeBadgeText: "Kostnadsfri första bedömning",
        statBlocks: [
            { value: "Gratis", label: "första bedömning" },
            { value: "12+", label: "års erfarenhet" },
            { value: "Hela", label: "Sverige" },
        ],
        services: [
            {
                title: "Saklig grund-bedömning",
                body: "Är uppsägningen verkligen sakligt grundad? Vi granskar arbetsgivarens motivering kritiskt.",
            },
            {
                title: "Arbetsbrist & turordning",
                body: "Har turordningsreglerna i LAS följts? Vi kontrollerar listor och eventuella avtalsturordningar.",
            },
            {
                title: "Personliga skäl",
                body: "Misskötsamhet, samarbetsproblem, arbetsvägran — vi utvärderar om kraven är uppfyllda.",
            },
            {
                title: "Avsked",
                body: "Avsked får bara ske vid grovt åsidosättande av åligganden. Vi prövar grunderna.",
            },
            {
                title: "Diskriminering",
                body: "Var uppsägningen baserad på ålder, kön, etnicitet, funktionsnedsättning eller graviditet?",
            },
            {
                title: "Skadestånd & lön",
                body: "Vi driver krav på allmänt och ekonomiskt skadestånd samt eventuell utebliven lön.",
            },
        ],
        process: [
            {
                title: "Kostnadsfri bedömning",
                body: "Vi går igenom din uppsägning, anställningsavtal och allt annat material — helt utan kostnad.",
            },
            {
                title: "Förhandling",
                body: "Vi tar kontakt med arbetsgivaren och förhandlar om återanställning eller skadestånd.",
            },
            {
                title: "Stämning",
                body: "Om förhandling inte räcker stämmer vi arbetsgivaren — i tingsrätt eller Arbetsdomstolen.",
            },
            {
                title: "Process & dom",
                body: "Vi företräder dig fullt ut genom hela domstolsprocessen.",
            },
        ],
        whyUs: [
            { title: "Kostnadsfri bedömning", body: "Inga åtaganden." },
            { title: "Erfaren arbetsrättsjurist", body: "12+ års erfarenhet." },
            { title: "Rättsskydd & rättshjälp", body: "Vi söker ersättning där möjligt." },
            { title: "Hela Sverige", body: "6 kontor + digitala möten." },
            { title: "Tydlig kommunikation", body: "Du vet alltid var ärendet står." },
            { title: "Strategiskt", body: "Vi väljer rätt väg — förlikning eller rätten." },
        ],
        faq: [
            {
                q: "Hur lång tid har jag på mig att bestrida en uppsägning?",
                a: "Du måste ogiltigförklara uppsägningen inom två veckor från att du fick den, eller väcka talan inom två veckor efter förhandlingens avslut. Vänta inte — kontakta oss direkt.",
            },
            {
                q: "Vad räknas som saklig grund?",
                a: "Saklig grund för uppsägning är antingen arbetsbrist eller personliga skäl. Personliga skäl kräver att arbetsgivaren först varnat och försökt omplacera dig. Vi bedömer om kraven är uppfyllda i ditt fall.",
            },
            {
                q: "Kan jag få skadestånd om uppsägningen är felaktig?",
                a: "Ja. Allmänt skadestånd kan utgå (typiskt 75 000–125 000 kr för felaktig uppsägning) plus ekonomiskt skadestånd för utebliven lön. Belopp varierar med omständigheter och anställningstid.",
            },
            {
                q: "Behöver jag vara fackmedlem?",
                a: "Nej, men om du är medlem i facket kan de hjälpa dig kostnadsfritt. Vi hjälper både fackmedlemmar och oorganiserade — och samverkar gärna med ditt fackförbund.",
            },
            {
                q: "Vad kostar det att anlita er?",
                a: "Första bedömningen är kostnadsfri. Vid fortsatt uppdrag undersöker vi om rättsskydd via försäkring eller rättshjälp kan användas — det täcker oftast det mesta av kostnaden.",
            },
        ],
        relatedPaket: [],
        relatedPages: [
            { label: "Alla rättsområden", to: "/tjanster" },
            { label: "Rättshjälp", to: "/rattshjalp" },
        ],
    },

    "bostadsratt-tvist": {
        slug: "bostadsratt-tvist",
        seoTitle: "Bostadsrättstvist — jurist för bostadsrättshavare",
        seoDescription:
            "Tvist med bostadsrättsföreningen, dolda fel vid köp eller störande granne? BM Juridik företräder bostadsrättshavare i hela Sverige.",
        eyebrow: "Fastighetsrätt",
        h1: "Bostadsrättstvist —",
        h1Italic: "din röst som boende.",
        intro:
            "Boende i bostadsrätt innebär en delikat balans mellan din rätt och föreningens beslut. När det blir tvist — om medlemskap, ombyggnad, störningar, dolda fel eller avgifter — krävs jurist med specifik erfarenhet av bostadsrättslagen.",
        primaryCta: "Boka rådgivning",
        ctaHref: "#kontakt",
        showFreeBadge: false,
        statBlocks: [
            { value: "12+", label: "års erfarenhet" },
            { value: "6", label: "kontor i Sverige" },
            { value: "100%", label: "specialkunskap" },
        ],
        services: [
            {
                title: "Dolda fel vid köp",
                body: "Reklamation och skadeståndsanspråk mot säljare när du upptäcker dolda fel efter tillträde.",
            },
            {
                title: "Tvist med föreningen",
                body: "Avgifter, renovering, beslut, vägrad medlemskap — vi företräder dig mot styrelsen.",
            },
            {
                title: "Störande granne",
                body: "Vi driver klagomål mot grannar som stör — via föreningen eller direkt mot grannen.",
            },
            {
                title: "Andrahandsuthyrning",
                body: "Föreningen vägrar tillåta andrahandsuthyrning? Vi prövar besluten.",
            },
            {
                title: "Renovering & ombyggnad",
                body: "Tvist om vad som är fastighetstillbehör eller bostadsrättshavarens ansvar.",
            },
            {
                title: "Föreningsstämmor",
                body: "Klandra felaktiga beslut fattade på stämman inom en månad.",
            },
        ],
        process: [
            {
                title: "Inledande genomgång",
                body: "Vi tar del av föreningens stadgar, beslut och relevant kommunikation. Vi utvärderar din position.",
            },
            {
                title: "Förhandling",
                body: "Många tvister kan lösas genom skriftlig kontakt med föreningen eller motpart.",
            },
            {
                title: "Stämning",
                body: "Om förhandling inte räcker stämmer vi i tingsrätt eller hyresnämnd beroende på fråga.",
            },
            {
                title: "Process & dom",
                body: "Vi företräder dig fullt ut tills tvisten är löst.",
            },
        ],
        whyUs: [
            { title: "Specialkunskap", body: "Bostadsrättslagen är vår vardag." },
            { title: "Rättsskydd", body: "Ofta tillgängligt via hemförsäkring." },
            { title: "Hela Sverige", body: "6 kontor + digitala möten." },
            { title: "Erfaren processjurist", body: "Vi vinner inte bara — vi förlikar smart." },
            { title: "Snabb återkoppling", body: "Tidiga åtgärder är viktigast." },
            { title: "Tydlig prismodell", body: "Inga dolda kostnader." },
        ],
        faq: [
            {
                q: "Vad räknas som dolt fel vid bostadsrätt?",
                a: "Dolda fel är fel som inte var upptäckbara vid normal undersökning före köpet och som väsentligt påverkar bostadens värde. Vanliga exempel: fukt-/mögelskador, läckage, dolda elinstallationsfel.",
            },
            {
                q: "Hur lång tid har jag på mig att reklamera dolt fel?",
                a: "Reklamation måste ske inom skälig tid efter att felet upptäckts — normalt 2-3 månader. Möjligheten att åberopa fel mot säljaren preskriberas efter två år. Kontakta oss snabbt.",
            },
            {
                q: "Kan föreningen vägra mig andrahandsuthyrning?",
                a: "Föreningen kan vägra utan beaktansvärda skäl. Du har rätt att begära att hyresnämnden prövar avslaget. Vi företräder dig under prövningen.",
            },
            {
                q: "Vad gör jag om en granne stör?",
                a: "Anmäl skriftligt till föreningen och spara dokumentation. Om föreningen inte agerar kan ärendet drivas via hyresnämnden eller — i grova fall — leda till förverkande av bostadsrätten.",
            },
            {
                q: "Vad kostar det?",
                a: "Det varierar med komplexitet. Många bostadsrättshavare har rättsskydd via hemförsäkring som täcker 75-80 % av kostnaderna. Vi söker ersättning där det är möjligt.",
            },
        ],
        relatedPaket: [],
        relatedPages: [
            { label: "Alla rättsområden", to: "/tjanster" },
            { label: "Rättshjälp", to: "/rattshjalp" },
        ],
    },

    arvsskifte: {
        slug: "arvsskifte",
        seoTitle: "Arvsskifte — jurist hjälper dödsboet med fördelningen",
        seoDescription:
            "Behöver ni hjälp med arvsskifte efter en närstående? BM Juridik upprättar arvskiftesavtal och företräder dödsboet i hela Sverige.",
        eyebrow: "Arvsskifte",
        h1: "Arvsskifte —",
        h1Italic: "klart, korrekt, rättvist.",
        intro:
            "Efter ett dödsfall ska tillgångarna fördelas mellan arvingarna. Arvsskiftet är det formella avtalet som reglerar fördelningen. Vi hjälper dödsboet att navigera juridiken — från bouppteckning till slutligt arvsskifte.",
        primaryCta: "Boka rådgivning",
        ctaHref: "#kontakt",
        showFreeBadge: false,
        statBlocks: [
            { value: "12+", label: "års erfarenhet" },
            { value: "Hela", label: "Sverige" },
            { value: "24h", label: "svar" },
        ],
        services: [
            { title: "Arvsskiftesavtal", body: "Skriftligt avtal mellan arvingarna som reglerar fördelningen av tillgångarna." },
            { title: "Tvist mellan arvingar", body: "När arvingar inte är överens hjälper vi till med medling och, vid behov, processföring." },
            { title: "Skifte vid testamente", body: "Vi tolkar testamentet och säkerställer att fördelningen följer den avlidnes vilja." },
            { title: "Internationella arv", body: "Tillgångar i annat land? Vi hanterar EU:s arvsförordning och utländsk arvsrätt." },
            { title: "Skiftesman", body: "När enighet inte kan nås kan tingsrätten förordna en skiftesman. Vi företräder dig under processen." },
            { title: "Skatt & deklaration", body: "Vi samverkar med skattejurist för korrekt arvsdeklaration och kapitalvinstberäkning." },
        ],
        process: [
            { title: "Genomgång av dödsboet", body: "Vi går igenom bouppteckningen, eventuellt testamente och tillgångarnas värde." },
            { title: "Uppgörelse mellan arvingar", body: "Vi förhandlar fram en fördelning som alla kan acceptera." },
            { title: "Arvsskiftesavtal", body: "Vi upprättar det juridiskt bindande avtalet och samordnar undertecknande." },
            { title: "Verkställighet", body: "Vi hjälper er med övergång av fastigheter, fonder och andra tillgångar till respektive arvinge." },
        ],
        whyUs: [
            { title: "Erfaren arvsrättsjurist", body: "12+ års erfarenhet av dödsbojuridik." },
            { title: "Helhetsgrepp", body: "Vi hanterar bouppteckning till skifte." },
            { title: "Hela Sverige", body: "6 kontor + digitala möten." },
            { title: "Diskretion", body: "Konfidentiell hantering." },
            { title: "Tydlig prismodell", body: "Inga överraskningar." },
            { title: "Snabb återkoppling", body: "24h svar." },
        ],
        faq: [
            { q: "När ska arvsskifte ske?", a: "Arvsskifte sker när bouppteckningen är registrerad och eventuella skulder är betalda. Det finns ingen lagstadgad tidsgräns, men det är klokt att inte vänta för länge." },
            { q: "Vad är skillnaden mellan bouppteckning och arvsskifte?", a: "Bouppteckning är en sammanställning av den avlidnes tillgångar och skulder. Arvsskifte är fördelningen av nettotillgångarna mellan arvingarna." },
            { q: "Vad händer om vi inte är överens?", a: "Om arvingarna inte kan enas kan tingsrätten förordna en skiftesman som beslutar om fördelningen. Vi företräder dig under processen." },
            { q: "Kan ett arv göras till enskild egendom?", a: "Ja, om det står i testamentet att arvet ska vara mottagarens enskilda egendom. Det skyddar arvet vid framtida skilsmässa." },
            { q: "Hur länge tar ett arvsskifte?", a: "Vid enighet och enkla tillgångar kan det göras på några veckor. Vid komplikationer (utländska tillgångar, tvister) kan det ta månader till år." },
        ],
        relatedPaket: ["bouppteckning"],
        relatedPages: [
            { label: "Bouppteckning", to: "/bouppteckning" },
            { label: "Testamente", to: "/testamente" },
            { label: "Bodelning", to: "/bodelning" },
        ],
    },

    bouppteckning: {
        slug: "bouppteckning",
        seoTitle: "Bouppteckning — vi hjälper dödsboet att uppfylla lagkravet",
        seoDescription:
            "Bouppteckning ska göras inom 3 månader efter dödsfallet. BM Juridik upprättar och registrerar bouppteckning till fast pris i hela Sverige.",
        eyebrow: "Bouppteckning",
        h1: "Bouppteckning —",
        h1Italic: "korrekt och i tid.",
        intro:
            "Bouppteckningen är dödsboets rättsliga inventering — en sammanställning av den avlidnes tillgångar och skulder som ska registreras hos Skatteverket inom tre månader. Vi hjälper er upprätta och registrera bouppteckningen smidigt.",
        primaryCta: "Boka rådgivning",
        ctaHref: "/paket?prod=bouppteckning",
        showFreeBadge: false,
        statBlocks: [
            { value: "3 mån", label: "lagstadgad frist" },
            { value: "Fast", label: "pris" },
            { value: "Hela", label: "Sverige" },
        ],
        services: [
            { title: "Inventering", body: "Vi hjälper er att kartlägga alla tillgångar — fastigheter, bankmedel, fonder, försäkringar, lösöre." },
            { title: "Värdering", body: "Korrekt värdering av tillgångar är avgörande — vi samverkar med värderingsmän när det behövs." },
            { title: "Skuldreglering", body: "Vi listar och hanterar dödsboets skulder, inklusive begravningskostnader och skatter." },
            { title: "Bouppteckningsförrättning", body: "Vi kallar till och leder bouppteckningsförrättningen där boets innehåll fastslås." },
            { title: "Registrering hos Skatteverket", body: "Vi sammanställer dokumentet och lämnar in det inom lagstadgad tid." },
            { title: "Komplettering & rättelser", body: "Hittas ny tillgång eller skuld efter registrering hjälper vi med tilläggsbouppteckning." },
        ],
        process: [
            { title: "Initialt möte", body: "Vi går igenom situationen med er och tar del av relevant dokumentation (testamente, äktenskapsförord m.m.)." },
            { title: "Inventering", body: "Vi sammanställer tillgångar och skulder med hjälp av banker, försäkringsbolag och Skatteverket." },
            { title: "Förrättning", body: "Vi kallar till bouppteckningsförrättning och leder mötet enligt formkraven." },
            { title: "Registrering", body: "Vi lämnar in bouppteckningen till Skatteverket och bevakar registreringen." },
        ],
        whyUs: [
            { title: "Lagkravet inom 3 mån", body: "Vi ser till att fristen hålls." },
            { title: "Fast pris", body: "Inga dolda kostnader." },
            { title: "Erfarenhet", body: "Hundratals bouppteckningar." },
            { title: "Helhetsgrepp", body: "Bouppteckning till arvsskifte." },
            { title: "Hela Sverige", body: "Fysiska eller digitala möten." },
            { title: "Snabb hantering", body: "Vanligtvis klar inom 4-6 veckor." },
        ],
        faq: [
            { q: "Måste alla dödsbon göra bouppteckning?", a: "Ja, om värdet på tillgångarna minus skulderna överstiger ca 24 000 kr. För mindre dödsbon räcker en s.k. dödsboanmälan från socialtjänsten." },
            { q: "Vad händer om vi missar 3-månadersfristen?", a: "Skatteverket kan förelägga om vite. Det är därför viktigt att starta processen tidigt. Vid behov kan anstånd begäras." },
            { q: "Vem ska närvara vid bouppteckningen?", a: "Den efterlevande maken/maka och alla legala arvingar ska kallas. Närvaro är inte obligatorisk men kallelse är ett formkrav." },
            { q: "Vad kostar en bouppteckning?", a: "Vårt fasta pris startar från 7 500 kr inkl. moms vid enkla bouppteckningar. Komplexa bouppteckningar kan vara dyrare — vi ger ett tydligt prisförslag i förväg." },
            { q: "Vad händer efter bouppteckningen?", a: "Efter registrering kan ni göra arvsskifte och fördela tillgångarna. Vi hjälper gärna med det också." },
        ],
        relatedPaket: ["bouppteckning"],
        relatedPages: [
            { label: "Arvsskifte", to: "/arvsskifte" },
            { label: "Testamente", to: "/testamente" },
        ],
    },

    framtidsfullmakt: {
        slug: "framtidsfullmakt",
        seoTitle: "Framtidsfullmakt — säkra ditt liv om du själv inte kan besluta",
        seoDescription:
            "En framtidsfullmakt ger den du litar på rätt att besluta om dina ekonomiska och personliga angelägenheter. BM Juridik upprättar lagligt giltig framtidsfullmakt.",
        eyebrow: "Framtidsfullmakt",
        h1: "Framtidsfullmakt —",
        h1Italic: "trygghet om livet förändras.",
        intro:
            "En framtidsfullmakt ger en person du litar på rätten att besluta om dina ekonomiska och personliga angelägenheter om du själv inte längre kan göra det. Det är ett enkelt och kraftfullt verktyg — men kräver korrekt formulering för att vara giltigt.",
        primaryCta: "Beställ framtidsfullmakt",
        ctaHref: "/paket?prod=framtidsfullmakt",
        showFreeBadge: false,
        statBlocks: [
            { value: "Fast", label: "pris från 2 500 kr" },
            { value: "1-2", label: "veckors leverans" },
            { value: "100%", label: "juristgranskat" },
        ],
        services: [
            { title: "Standardfullmakt", body: "Reglerar både ekonomiska och personliga angelägenheter — den vanligaste formen." },
            { title: "Begränsad fullmakt", body: "Ger fullmaktshavaren rätt enbart inom ett specifikt område, t.ex. ekonomi." },
            { title: "Med villkor", body: "Anpassade villkor om när fullmakten ska träda i kraft eller upphöra." },
            { title: "Flera fullmaktshavare", body: "Två eller flera personer kan utses gemensamt eller var för sig." },
            { title: "Förvar & registrering", body: "Vi rekommenderar säker förvaring så att fullmakten finns tillgänglig när den behövs." },
            { title: "Återkallelse & uppdatering", body: "Vi hjälper dig att uppdatera eller återkalla fullmakten." },
        ],
        process: [
            { title: "Kartläggning", body: "Vi går igenom din situation, vem du vill utse och vad fullmakten ska omfatta." },
            { title: "Upprättande", body: "Vi formulerar fullmakten enligt lagens krav — med dina specifika önskemål." },
            { title: "Granskning", body: "Du går igenom dokumentet. När du är nöjd godkänner du det." },
            { title: "Bevittning", body: "Vi guidar genom kraven på bevittning för att fullmakten ska vara giltig." },
        ],
        whyUs: [
            { title: "Fast pris", body: "Från 2 500 kr inkl. moms." },
            { title: "Juristgranskat", body: "Inte mall — anpassat till dig." },
            { title: "Snabb leverans", body: "1-2 veckor." },
            { title: "Hela Sverige", body: "Digitalt eller fysiskt möte." },
            { title: "Tydliga instruktioner", body: "Vi förklarar exakt vad som gäller." },
            { title: "Möjlighet till uppdatering", body: "Reviderbart till rabatterat pris." },
        ],
        faq: [
            { q: "När börjar framtidsfullmakten gälla?", a: "Den träder i kraft när fullmaktshavaren bedömer att du inte längre kan ta hand om dina angelägenheter. Bedömningen baseras normalt på läkarintyg." },
            { q: "Kan jag återkalla fullmakten?", a: "Ja, så länge du har förmåga att fatta beslut kan du återkalla eller ändra fullmakten när som helst." },
            { q: "Vad är skillnaden mot en god man?", a: "Framtidsfullmakt är en privat lösning som du själv valt i förväg. God man utses av tingsrätten när någon redan tappat sin rättsliga handlingsförmåga." },
            { q: "Måste fullmakten registreras?", a: "Nej, det finns inget officiellt register. Dock är det klokt att förvara den säkert och informera anhöriga om var den finns." },
            { q: "Vad kostar en framtidsfullmakt?", a: "Vårt fasta pris är 2 500 kr inkl. moms för en standardfullmakt. Komplexa fullmakter med flera fullmaktshavare och särskilda villkor kan vara något dyrare." },
        ],
        relatedPaket: ["framtidsfullmakt"],
        relatedPages: [
            { label: "Testamente", to: "/testamente" },
            { label: "Familjerätt", to: "/tjanster#familjeratt" },
        ],
    },

    samboavtal: {
        slug: "samboavtal",
        seoTitle: "Samboavtal — säkra era ekonomiska intressen som sambor",
        seoDescription:
            "Ett samboavtal reglerar vad som ska hända med era tillgångar om förhållandet upphör. BM Juridik upprättar samboavtal till fast pris.",
        eyebrow: "Samboavtal",
        h1: "Samboavtal —",
        h1Italic: "tydligt avtal, tryggt sambolivet.",
        intro:
            "Sambor delar bara samboegendom (gemensam bostad och bohag som införskaffats för gemensamt bruk) — inte all egendom som makar gör. Med ett samboavtal kan ni förtydliga vad som gäller och anpassa fördelningen om förhållandet upphör.",
        primaryCta: "Beställ samboavtal",
        ctaHref: "/paket?prod=samboavtal",
        showFreeBadge: false,
        statBlocks: [
            { value: "Fast", label: "pris från 2 900 kr" },
            { value: "1-2", label: "veckors leverans" },
            { value: "100%", label: "juristgranskat" },
        ],
        services: [
            { title: "Avtal om samboegendom", body: "Reglera att bodelning inte ska ske, eller att vissa tillgångar ska undantas." },
            { title: "Skuldfördelning", body: "Klargör hur lån och skulder ska hanteras — t.ex. bostadslån." },
            { title: "Köpeavtal", body: "Vid gemensamma köp av bostad eller annan dyr egendom dokumenterar vi äganderätten." },
            { title: "Avtal vid separation", body: "Anpassad lösning om hur ekonomin ska skiljas åt vid en framtida separation." },
            { title: "Rätt vid dödsfall", body: "Sambor ärver inte automatiskt — vi kombinerar samboavtal med testamente för helhetslösning." },
            { title: "Översyn vid livsförändring", body: "Vid köp av bostad, gemensamt företag eller barn — vi uppdaterar avtalet." },
        ],
        process: [
            { title: "Genomgång av situationen", body: "Vi går igenom era tillgångar, skulder och hur ni vill att samboendet ska regleras." },
            { title: "Strukturering", body: "Vi översätter era önskemål till juridiskt korrekt formulering." },
            { title: "Granskning", body: "Ni får dokumentet och kan ställa frågor. När båda är nöjda godkänner ni." },
            { title: "Underskrift", body: "Avtalet undertecknas av båda parter — formkrav är låga, men vi guidar." },
        ],
        whyUs: [
            { title: "Fast pris", body: "Från 2 900 kr inkl. moms." },
            { title: "Juristgranskat", body: "Inte mall." },
            { title: "Snabb leverans", body: "1-2 veckor." },
            { title: "Helhetsgrepp", body: "Kombinerat med testamente vid behov." },
            { title: "Hela Sverige", body: "Digitalt eller fysiskt möte." },
            { title: "Tydliga råd", body: "Vi förklarar konsekvenser." },
        ],
        faq: [
            { q: "Vad gäller om vi inte har samboavtal?", a: "Sambolagen tillämpas: bostad och bohag som införskaffats för gemensamt bruk fördelas lika vid separation. Annan egendom (bil, sparande, företag) delas inte." },
            { q: "Kan vi själva skriva ett samboavtal?", a: "Tekniskt ja — formkraven är låga. Men ett juristgranskat avtal är skarpare formulerat och håller bättre vid en framtida tvist." },
            { q: "Hur länge gäller ett samboavtal?", a: "Tills det skrivs om eller tills samboförhållandet upphör. Vid gifte upphör samboavtalet automatiskt — då kan ni istället ha äktenskapsförord." },
            { q: "Måste avtalet registreras?", a: "Nej, samboavtal registreras inte officiellt — till skillnad från äktenskapsförord. Förvara det säkert." },
            { q: "Vad kostar samboavtalet?", a: "Vårt fasta pris är 2 900 kr inkl. moms. Komplexa avtal med särskilda villkor (företag, fastigheter) kan vara något dyrare." },
        ],
        relatedPaket: ["samboavtal", "testamente"],
        relatedPages: [
            { label: "Testamente", to: "/testamente" },
            { label: "Äktenskapsförord", to: "/aktenskapsforord" },
            { label: "Bodelning", to: "/bodelning" },
        ],
    },

    aktenskapsforord: {
        slug: "aktenskapsforord",
        seoTitle: "Äktenskapsförord — gör tillgångar till enskild egendom",
        seoDescription:
            "Ett äktenskapsförord är ett formellt avtal mellan makar som gör tillgångar till enskild egendom — vilket inte delas vid skilsmässa. Fast pris.",
        eyebrow: "Äktenskapsförord",
        h1: "Äktenskapsförord —",
        h1Italic: "tydligt skydd, tryggt äktenskap.",
        intro:
            "Med ett äktenskapsförord kan ni göra tillgångar till enskild egendom — vilket innebär att de inte delas vid en eventuell skilsmässa. Det är särskilt vanligt vid företagsägande, arv eller vid omgifte. Vi upprättar och registrerar avtalet enligt alla formkrav.",
        primaryCta: "Beställ äktenskapsförord",
        ctaHref: "/paket?prod=aktenskapsforord",
        showFreeBadge: false,
        statBlocks: [
            { value: "Fast", label: "pris från 3 200 kr" },
            { value: "1-2", label: "veckors leverans" },
            { value: "Skatte-", label: "verket-registrerat" },
        ],
        services: [
            { title: "Standardförord", body: "Allt eller delar av era tillgångar görs till enskild egendom — i båda riktningar." },
            { title: "Ensidigt förord", body: "Endast en av makarnas egendom görs till enskild — t.ex. ärvda tillgångar." },
            { title: "Företagsskydd", body: "Säkerställer att ditt företag inte berörs av en framtida skilsmässa." },
            { title: "Vid omgifte", body: "Skyddar barn från tidigare relationer genom att rita upp arvslinjer tydligt." },
            { title: "Registrering", body: "Vi sköter inlämning till Skatteverket — ett krav för att förordet ska gälla." },
            { title: "Ändring & återkallelse", body: "Förord kan när som helst ändras eller återkallas genom nytt registrerat förord." },
        ],
        process: [
            { title: "Genomgång", body: "Vi går igenom era tillgångar och vad ni vill skydda. Vi ger juridisk rådgivning kring konsekvenser." },
            { title: "Upprättande", body: "Vi formulerar förordet med precisa juridiska skrivningar." },
            { title: "Underskrift", body: "Båda makarna undertecknar förordet." },
            { title: "Registrering", body: "Vi lämnar in det till Skatteverket — först då blir det giltigt." },
        ],
        whyUs: [
            { title: "Fast pris", body: "Från 3 200 kr inkl. moms." },
            { title: "Registrering ingår", body: "Vi sköter Skatteverket." },
            { title: "Juristgranskat", body: "Skarpare än mall." },
            { title: "Snabb leverans", body: "1-2 veckor." },
            { title: "Hela Sverige", body: "Digitalt eller fysiskt." },
            { title: "Helhetsråd", body: "Kombinerat med testamente." },
        ],
        faq: [
            { q: "Vad händer utan äktenskapsförord?", a: "Då gäller giftorätt. Vid skilsmässa delas alla tillgångar lika oavsett vem som ägt dem — undantaget enskild egendom genom arv eller gåva med villkor." },
            { q: "När kan man skriva äktenskapsförord?", a: "När som helst — innan, vid eller under äktenskapet. Det måste registreras hos Skatteverket för att gälla." },
            { q: "Är äktenskapsförord oromantiskt?", a: "Tvärtom — det visar att ni har talat om de svåra frågorna och valt att skydda varandra och eventuella företag, barn eller arv." },
            { q: "Kan vi ångra oss?", a: "Ja, ett äktenskapsförord kan när som helst ändras eller upphävas — genom ett nytt registrerat förord." },
            { q: "Vad kostar äktenskapsförord?", a: "Vårt fasta pris är 3 200 kr inkl. moms inkl. registrering hos Skatteverket. Komplexa förord (företag, fastigheter) kan vara något dyrare." },
        ],
        relatedPaket: ["aktenskapsforord", "testamente"],
        relatedPages: [
            { label: "Testamente", to: "/testamente" },
            { label: "Samboavtal", to: "/samboavtal" },
            { label: "Bodelning", to: "/bodelning" },
        ],
    },
};

export const LANDING_PAGE_LIST = Object.values(LANDING_PAGES).map((p) => ({
    slug: p.slug,
    title: p.eyebrow,
    description: p.seoDescription,
}));
